import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { CORE_USER_SETTINGS_QUERY_KEY } from "./useCoreUserSettings";

export const useInvalidateCoreUserSettings = () => {
  const queryClient = useQueryClient();
  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: CORE_USER_SETTINGS_QUERY_KEY
    });
  }, [queryClient]);
};
